import { GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid-premium';
import { createSlice } from '@reduxjs/toolkit';
import StkAutoCikisDetayDTO from 'src/models/StokEczane/CikisDetay/StkAutoCikisDetayDTO';
import VwStkCikisDetayDTO from 'src/models/StokEczane/CikisDetay/VwStkCikisDetayDTO';
import VwStkGirisegoredepostokdurumDTO from 'src/models/StokEczane/StokDurum/VwStkGirisegoredepostokdurumDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { DepoTalepApi } from 'src/services/StokEczane/DepoTalepApi';
import { StokDurumApi } from 'src/services/StokEczane/StokDurumApi';

interface IStokCikisDetayState {
  isOpenDetay: boolean;
  stokCikisId: number;
  stokCikisDetayId: number;
  stkDurumYenile: boolean;
  giriseGoreStkDurumList: Array<VwStkGirisegoredepostokdurumDTO>;
  excelSablonYukleListe: Array<StkAutoCikisDetayDTO>;
  cikisDetayList: Array<VwStkCikisDetayDTO>;
  onyasizKayitlar: Array<StkAutoCikisDetayDTO>;
}

const StokCikisDetaySlice = createSlice<
  IStokCikisDetayState,
  MapReducerPayloads<
    IStokCikisDetayState,
    {
      setIsOpenDetay: boolean;
      setStokCikisId: number;
      setStokCikisDetayId: number;
      setStokDurumYenile: boolean;
      setGiriseGoreStkDurumList: Array<VwStkGirisegoredepostokdurumDTO>;
      setExcelSablonYukleListe: Array<StkAutoCikisDetayDTO>;
      setCikisDetayList: Array<VwStkCikisDetayDTO>;
      setOnyasizKayitlar: Array<StkAutoCikisDetayDTO>;
    }
  >
>({
  name: 'StokCikisDetay',
  initialState: {
    isOpenDetay: false,
    stokCikisId: null,
    stokCikisDetayId: null,
    stkDurumYenile: false,
    giriseGoreStkDurumList: [],
    excelSablonYukleListe: new Array<StkAutoCikisDetayDTO>(),
    cikisDetayList: new Array<VwStkCikisDetayDTO>(),
    onyasizKayitlar: new Array<StkAutoCikisDetayDTO>(),
  },
  reducers: {
    setIsOpenDetay: (state, action) => {
      state.isOpenDetay = action.payload;
    },
    setStokCikisId: (state, action) => {
      state.stokCikisId = action.payload;
    },
    setStokCikisDetayId: (state, action) => {
      state.stokCikisDetayId = action.payload;
    },
    setStokDurumYenile: (state, action) => {
      state.stkDurumYenile = action.payload
    },
    setGiriseGoreStkDurumList: (state, action) => {
      state.giriseGoreStkDurumList = action.payload
    },
    setExcelSablonYukleListe: (state, action) => {
      state.excelSablonYukleListe = action.payload
    },
    setCikisDetayList: (state, action) => {
      state.cikisDetayList = action.payload
    },
    setOnyasizKayitlar: (state, action) => {
      state.onyasizKayitlar = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(StokDurumApi.endpoints.getStokGirisDurumList.matchFulfilled, (state, action) => {
      state.giriseGoreStkDurumList = action.payload;
    })
  }
});

export default StokCikisDetaySlice;
